import ViewSalesInvoice from "../../../../components/@documents/sales_invoices/ViewSalesInvoice";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesInvoiceViewPage() {

    return (
        <ViewSalesInvoice 
            routeType={routeTypes.admin}
        />
    )
}